/**
 * Utility for formatting category names from camelCase to display format
 */

/**
 * Format a camelCase string into a proper display format
 * Example: "socialMedia" -> "Social Media"
 */
export const formatCamelCase = (text: string): string => {
  // First match any camelCase pattern and add spaces
  const spaced = text.replace(/([A-Z])/g, ' $1').trim();
  // Then capitalize first letter
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

/**
 * Format a category name, handling special cases
 */
export const formatCategoryName = (category: string): string => {
  // Handle acronyms
  const acronyms: Record<string, string> = {
    'ai': 'AI',
    'mma': 'MMA',
    'ufo': 'UFO',
  };

  // Check if it's an acronym
  if (acronyms[category.toLowerCase()]) {
    return acronyms[category.toLowerCase()];
  }

  // Otherwise use the camelCase formatter
  return formatCamelCase(category);
};

/**
 * Generate translations for all categories in an array
 */
export const generateCategoryTranslations = (categories: string[]): Record<string, string> => {
  const translations: Record<string, string> = {};
  
  categories.forEach(category => {
    const lowerKey = category.toLowerCase();
    translations[lowerKey] = formatCategoryName(category);
  });
  
  return translations;
}; 